import { createSlice } from '@reduxjs/toolkit'

type Nullable<T> = T | null

type PlainInfo<T> = {
  status: RequestState
  error?: string
  data: Nullable<T>
}

type RequestState = 'pending' | 'fulfilled' | 'rejected' | 'none'

const initialState: PlainInfo<Promotion[]> = {
  status: 'none',
  data: [],
  error: undefined,
}

export const promotionSlice = createSlice({
  name: '@promotion',
  initialState,
  reducers: {},
})
